import { Injectable, OnInit } from "@angular/core";
import * as firebase from "firebase";
import "rxjs/add/operator/take";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Notification, isFromConversation } from "../../fiscalia/domain/notification";
import { Observable } from "rxjs/Observable";
import { Http, RequestMethod, Response } from "@angular/http";
import { environment } from "environments/environment";
import { AuthService } from "app/core/security/auth.service";
import { GenericService } from "app/core/commons/generic.service";
import { QueryOptions } from "app/core/commons/query.options";
import { Message } from "app/fiscalia/domain/message";
@Injectable()
export class MessagingService extends GenericService<Notification> {
  public getDefaultQueryOptions(): QueryOptions {
    return new QueryOptions();
  }

  protected valueToEntity(value: any): Notification | Observable<Notification> {
    return new Notification(value);
  }
  protected getResourcePath(): string {
    return "/notification";
  }

  private _base_url: string = environment.backendHost;
  private _notification_url = "/api/notification";

  messaging: any;
  n = {
    id: null,
    title: null,
    body: null,
    redirectTo: null,
    viewed: null,
    payload: null,
    icon: null,
    emittedTime: null
  };
  currentMessage = new BehaviorSubject(this.n);
  updateSubject = new BehaviorSubject(null);
  currentConversationId = new BehaviorSubject(null);

  constructor(authService: AuthService, private _http: Http) {
    super(authService);
    const config = {
      apiKey: "AIzaSyDdCH5MElWL6193xqouKSEOapyhiFNugg0",
      authDomain: "abogadosdelestado-72ca8.firebaseapp.com",
      databaseURL: "https://abogadosdelestado-72ca8.firebaseio.com",
      projectId: "abogadosdelestado-72ca8",
      storageBucket: "abogadosdelestado-72ca8.appspot.com",
      messagingSenderId: "833525586462",
      appId: "1:833525586462:web:dddfc6b3ca1c0c4adcac0f"
    };
    
    firebase.initializeApp(config);
    this.messaging = firebase.messaging();

    this.currentConversationId.subscribe(id => {
      if(id != null){
        this.setViewedConversation(id).subscribe();
      }
    })
  }

  getPermission() {
    this.messaging
      .requestPermission()
      .then(() => {
        return this.messaging.getToken();
      })
      .then(token => {
        this.updateToken(token);
      })
      .catch(err => {
        console.error("Unable to get permission to notify.", err);
      });
  }

  receiveMessage() {
    this.messaging.onMessage(payload => {
      let n = {
        id: payload.data.id,
        title: payload.data.title,
        body: payload.data.body,
        redirectTo: payload.data.redirectTo,
        viewed: payload.data.viewed,
        payload: payload.data.payload,
        icon: payload.data.icon,
        emittedTime: payload.data.emittedTime
      };

      const notification = new Notification(n);
      if (this.currentConversationId.getValue() != null &&
         isFromConversation(notification, this.currentConversationId.getValue())) {
        notification.viewed = 1;
        this.setViewed(notification.id).subscribe(() => {
          this.currentMessage.next(notification);
        });
      } else {
        this.currentMessage.next(notification);
      }

    });
  }

  public currentMessageObservable(): Observable<Notification> {
    return this.currentMessage.asObservable();
  }

  get base_url(): string {
    return this._base_url;
  }

  get notification_url(): string {
    return this._notification_url;
  }

  updateToken(token) {
    this.doRequest({
      url: this.base_url + this.notification_url + "/updateToken",
      method: RequestMethod.Post,
      body: JSON.stringify({
        token: token
      })
    }).subscribe();
  }

  setViewed(id: number): Observable<Response> {
    return this.doRequest({
      url: this.base_url + this.notification_url + "/setViewed",
      method: RequestMethod.Post,
      body: JSON.stringify({
        id: id
      })
    });
  }

  

  setViewedConversation(id: number): Observable<Response> {
    this.updateSubject.next(1);
    return this.doRequest({
      url: this.base_url + this.notification_url + "/setViewedConversation",
      method: RequestMethod.Post,
      body: JSON.stringify({
        id: id
      })
    });
  }

}

/*
curl -X POST \
  https://fcm.googleapis.com/fcm/send \
  -H 'Authorization: key=AAAAtSKJ7jE:APA91bFWriqVXIcnmbs_BJdWr5j6AVWZARDTIYALaJ64Fh0b970ACdeQ4EMlYWlX7Z_B6MmY3szUllFTHb48lZrMg46o4AgCcthVSBVQh-5nD-g3UenhuYgz2yZR2i6Un5H7_PkKPtGv' \
  -H 'Content-Type: application/json' \
  -d '{
    "data": {
    "id": 1,
    "title": "Nuevo mensaje",
    "body": "This is Message from Admin",
    "redirectTo": "home/chat",
    "viewed": 0,
    "icon": "email",
    "emittedTime": 1552769325141
  },
  "to" : "cl8e0fINiRc:APA91bE6maTGxnkLGl07-Ia4LIJwi703VovUQGkOyBptElavuh5zSJkgvWiwUhHdkhjnhQJzPRYN7P0XmiD7ftG-UowXDb6CzGkykcnw6m9QTWQyboX4XGmoALu6o_z42px5piLJddq2"
}'
*/



// WEBPACK FOOTER //
// ./src/app/home/service/messaging.service.ts